<template>
  <div>
    <v-data-table
      v-if="items.length"
      :total-items="1"
      :headers="showSales ? paymentHeaders : noStaffSaleHeader"
      :items="items"
      disable-initial-sort
      hide-actions
      :no-data-text="$t('Views.Goods.noData')"
    >
      <!-- headers插槽 -->
      <template v-slot:headers="props">
        <tr>
          <template v-for="(header, index) in props.headers">
            <th
              :key="header.text"
              class="th-text"
              :style="index == 2 ? `text-align:right;` : ''"
            >
              {{ header.text }}
            </th>
          </template>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td style="text-align:center;width:120px">
            <div v-if="showSales">
              {{ formatDate(props.item.paymentTime) }}
            </div>
            <div v-else>
              {{ formatDate(props.item.rechargeTime) }}
            </div>
          </td>
          <td style="text-align:center;width:100px">
            <div class="product-name-container-center">
              <div class="fix-left" style="min-width:150px;text-align:left;">
                {{ props.item.paymentMethodName }}
              </div>
            </div>
          </td>
          <td style="text-align:right;width:220px">
            <div v-if="props.item.id">
              {{ props.item.amount | moneyFmt(currenyName) }}
            </div>
            <div v-else>
              <v-form ref="form" v-model="valid">
                <v-text-field
                  v-model="props.item.amount"
                  v-formatinput:[currenyName]="{
                    handle: handleFormat,
                    key: iptKey,
                    map: `${iptMap}.${props.index}`
                  }"
                  :rules="rules"
                />
              </v-form>
            </div>
          </td>
          <td style="text-align:center;width:260px">
            <div v-if="props.item.id">
              {{ props.item.operatorName }}
            </div>
            <v-select
              v-else
              v-model="props.item.operatorId"
              :items="staffList"
              :item-value="items => items.id"
              :item-text="items => items.name"
              :placeholder="$t('Views.Order.chooseChargeStaff')"
              :no-data-text="$t('Views.Goods.noData')"
            />
          </td>
          <td style="text-align:center;width:500px">
            <div v-if="props.item.id">
              {{ props.item.remark }}
            </div>
            <v-text-field
              v-else
              v-model="props.item.remark"
              :counter="50"
              maxlength="50"
            />
          </td>
        </tr>
      </template>
      <!-- no-data插槽 -->
      <template v-slot:no-data>
        <div class="no-data">
          <v-icon class="nodataicon" :color="color">
            mdi-alert
          </v-icon>
          <div>  {{ $t("Views.Goods.noData") }}</div>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { format } from 'date-fns'
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    /*eslint-disable*/
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    currenyName: String,
    showSales: {
      type: Boolean,
      default: true
    },
    iptKey: '',
    iptMap: '',
    rules:{
       type: Array,
      default: () => {
        return []
      }
    },
    staffList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    const $t = this.$t.bind(this)
    return {
      valid: false,
      //月结现结
      paymentHeaders: [
        {
          text: $t('Views.Order.chargeDate'),
          value: 'paymentTime'
        }, {
          text: $t('Views.Finance.methodspay'),
          value: 'paymentMethodName'
        }, {
          text: $t('Views.Order.chargeAmount'),
          value: 'amount',
          align: 'right'
        },
        {
          text: $t('Views.Order.chargeStaff'),
          value: 'operatorId'
        },
        {
          text: $t('Views.Finance.remark'),
          value: 'remark'
        }
      ],
      //预付款
      noStaffSaleHeader: [
        {
          text: $t('Views.Finance.dateTime'),
          value: 'rechargeTime'
        }, {
          text: $t('Views.Finance.paymethods'),
          value: 'paymentMethodName'
        }, {
          text: $t('Views.Finance.rechargeAmount'),
          value: 'amount',
          align: 'right'
        },
        {
          text: $t('Views.Order.chargeStaff'),
          value: 'operatorId'
        },
        {
          text: $t('Views.Finance.remark'),
          value: 'remark'
        }
      ]
      // staffList: []
    }
  },
  computed: {
    color() {
      return this.$store.state.app.color
    },
    ...mapState('setting', ['staffAllData'])
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions('setting', ['getStaffAllData']),
    handleFormat(value, key, form) {
      this.$emit('gettableData', value, key, form)
    },
    formatPrice(num) {
      return this.$util.data.toThousands(num)
    },
    formatDate(date) {
      if (date) {
        return format(date, 'YYYY-MM-DD')
      }
    }
  }
}
</script>
<style lang="scss">
.th-text {
  
  font-size: 14px !important;
  color: #515151 !important;
  letter-spacing: 0;
  font-weight: bold !important;
}
</style>
